import { Box, Card, Avatar, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

// Statistici elev pe Dashboard; props: [{ icon, value, label, color, valueColor }]
export default function StudentStats({ stats = [] }) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 2, sm: 3 }, width: '100%' }}>
      {stats.map((stat) => (
        <Box
          key={stat.label}
          sx={{ flex: { xs: '0 0 calc(50% - 8px)', sm: '0 0 calc(25% - 18px)' } }}
        >
          <Card sx={{
            borderRadius: 3,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            p: { xs: 2, sm: 3 },
            minHeight: 120
          }}>
            <Avatar sx={{
              width: { xs: 44, sm: 52 },
              height: { xs: 44, sm: 52 },
              mb: 1,
              bgcolor: stat.color ? alpha(stat.color, 0.1) : undefined,
              color: stat.color || undefined,
              '& .MuiSvgIcon-root': {
                fontSize: { xs: '1.3rem', sm: '1.6rem' }
              }
            }}>
              {stat.icon}
            </Avatar>
            <Typography
              variant="h3"
              fontWeight="bold"
              color={stat.valueColor}
              sx={{ fontSize: { xs: '1.3rem', sm: '1.6rem' }, lineHeight: 1.2 }}
            >
              {stat.value}
            </Typography>
            <Typography variant="body2" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' }, textAlign: 'center' }}>
              {stat.label}
            </Typography>
          </Card>
        </Box>
      ))}
    </Box>
  );
}
